<template>
  <!-- Ratings total: start -->
  <div class="flex-col items-end justify-center gap-2 text-center">
    <div class="mb-3">
      <p
        class="cursor-pointer"
        v-if="activeRatingsView == 'percentage'"
        @click="toggleView('absolute')"
      >
        %
      </p>
      <p
        class="cursor-pointer"
        v-if="activeRatingsView == 'absolute'"
        @click="toggleView('percentage')"
      >
        #
      </p>
    </div>

    <div>
      <div class="flex items-center justify-center gap-2">
        <div class="w-1/2 text-right flex justify-end mr-2">{{ totalPlusResult }}</div>
        <div class="w-1/2 text-right flex justify-end mr-2">{{ totalMinusResult }}</div>
      </div>
    </div>
  </div>
  <!-- Ratings total: end -->
</template>

<script>
export default {
  name: 'ProfileRatingsTotal',

  props: {
    session: {
      type: Object,
    }, 
    ratingsView: {
      type: String,
      default: 'absolute',
    },
    ratingStats: {
      type: Object,
    },
  },

  data() {
    return {
      activeRatingsView: this.ratingsView || 'absolute',
      totalPlus: this.ratingStats.totalPlus || 0,
      totalMinus: this.ratingStats.totalMinus || 0,
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.profile-ratings.submitted',
      (e) => {
        console.log('profile-ratings.submitted');

        this.totalPlus = e.ratings.totalPlus || 0;
        this.totalMinus = e.ratings.totalMinus || 0;
      }
    );
  },

  methods: {
    toggleView(view) {
      this.activeRatingsView = view;

      this.$emit(
        'ratingsViewToggled',
        view
      );
    },
  },

  computed: {
    totalPlusResult() {
      if(this.activeRatingsView == 'percentage') {
        if(this.session.participants_count <= 0) {
          return 0;
        }

        return ((this.totalPlus / this.session.participants_count) * 100).toFixed(0);
      }

      return this.totalPlus;      
    },

    totalMinusResult() {
      if(this.activeRatingsView == 'percentage') {
        if(this.session.participants_count <= 0) {
          return 0;
        }

        return ((this.totalMinus / this.session.participants_count) * 100).toFixed(0);
      }

      return this.totalMinus;      
    },
    // plusPercentage() {
    //   if (this.totalPlus <= 0 || !this.ratings.plus) {
    //     return 0;
    //   }

    //   return ((this.ratings.plus / this.totalPlus) * 100).toFixed(0);
    // },

    // minusPercentage() {
    //   if (this.totalMinus <= 0 || !this.ratings.minus) {
    //     return 0;
    //   }

    //   return ((this.ratings.minus / this.totalMinus) * 100).toFixed(0);
    // },

    // maxPlusPercentage() {
    //   if (this.totalPlus <= 0 || !this.maxPlus) {
    //     return null;
    //   }

    //   return ((this.maxPlus / this.totalPlus) * 100).toFixed(0);
    // },

    // maxMinusPercentage() {
    //   if (this.totalMinus <= 0 || !this.maxMinus) {
    //     return null;
    //   }

    //   return ((this.maxMinus / this.totalMinus) * 100).toFixed(0);
    // },

    // plus() {
    //   return this.ratings.plus || 0;
    // },

    // minus() {
    //   return this.ratings.minus || 0;
    // },
  },
};
</script>